import { BLUE, BLUE_PRESSED, BORDER, INK, INTER, SLATE, YELLOW, YELLOW_HOVER } from '../mockupPalette';

export * from '../mockupPalette';

export const MUTED = SLATE;

export const cardSx = {
    backgroundColor: '#fff',
    border: `1px solid ${BORDER}`,
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(22, 58, 99, 0.08)',
};

export const primaryButtonSx = {
    fontFamily: INTER,
    fontWeight: 700,
    fontSize: '15px',
    minHeight: '44px',
    borderRadius: '11px',
    backgroundColor: BLUE,
    color: '#FFFFFF',
    boxShadow: 'none',
    textTransform: 'none' as const,
    '&:hover': {
        backgroundColor: BLUE_PRESSED,
        boxShadow: 'none',
    },
};

export const aiButtonSx = {
    fontFamily: INTER,
    fontWeight: 700,
    fontSize: '15px',
    minHeight: '44px',
    borderRadius: '11px',
    backgroundColor: YELLOW,
    color: INK,
    boxShadow: 'none',
    textTransform: 'none' as const,
    '&:hover': {
        backgroundColor: YELLOW_HOVER,
        boxShadow: 'none',
    },
};
